export default {
  SET_CUSTOMER: 'SET_CUSTOMER',
  GET_CUSTOMER: 'GET_CUSTOMER',
};
